const handleQuickTable = (
  quickArray,
  dispatch,
  updateLevel2Properties,
  Sheetid
) => {
  console.log(quickArray);
  if (quickArray.length > 0) {
    dispatch(
      updateLevel2Properties({
        reduxKey: "quickTable",
        Sheetid: Sheetid,
        parentKey: "actions",
        value: quickArray,
        itemInArray: false,
        index: null,
      })
    );
  }
};
const handleNumberObjectForQuickTable = (
  index,
  updatedItem,
  dispatch,
  updateLevel2Properties,
  Sheetid
) => {
  dispatch(
    updateLevel2Properties({
      reduxKey: "valueColumns",
      Sheetid: Sheetid,
      parentKey: "query",
      value: updatedItem,
      itemInArray: true,
      index: index,
    })
  );
};

const findMatchedItems = (mergedArray, sortArray) => {
  // console.log(mergedArray);
  // console.log(sortArray);

  if (sortArray.length === 0) {
    let firstItemIndex = 0;
    const firstItem = mergedArray[firstItemIndex];
    return [firstItem];
  } else {
    const filteredSortArray = sortArray.filter((sortItem) =>
      mergedArray.some((mergedItem) => mergedItem.uuid === sortItem.uuid)
    );
    if (filteredSortArray.length === sortArray.length) {
      return filteredSortArray;
    } else {
      console.error(
        "Some items in sortArray were not present in mergedArray, returning filtered list."
      );
      return filteredSortArray;
    }
  }
};
function getDateUnitFormat(dateUnit) {
  const formats = {
    Years: "%Y",
    Quarter: "%Q",
    Months: "%M",
    Days: "%d",
    Weeks: "%W",
  };

  return formats[dateUnit] || null; // Return null for unsupported values
}

const breakValue = (input, calledFrom) => {
  console.log(input);
  const parts = input.split(" ");
  console.log(input.split(" "));

  console.log(parts.length === 3);
  console.log(calledFrom);

  if (parts.length === 3) {
    console.log(parts[0]);
    console.log(parts[1]);
    console.log(parts[2]);

    return {
      period: parts[0], // "last"
      value: parts[1], // "5"
      unit: parts[2], // "days"
    };
  }
  if (
    (parts.length === 2 && calledFrom === "dateConfigComp") ||
    (parts.length === 2 && calledFrom === "aside3SideBar")
  ) {
    console.log("hi");

    if (parts[0] === "Last") {
      return {
        period: 0,
        value: undefined,
        unit: parts[1],
      };
    } else if (parts[0] === "This") {
      return {
        period: 1,
        value: undefined,
        unit: parts[1],
      };
    } else if (parts[0] === "Next") {
      return {
        period: 2,
        value: undefined,
        unit: parts[1],
      };
    } else {
      return false;
    }
  }
  if (parts.length === 2 && calledFrom === "buildQuery") {
    return false;
  }
  if (
    (parts.length === 1 && calledFrom === "dateConfigComp") ||
    (parts.length === 1 && calledFrom === "aside3SideBar")
  ) {
    console.log(input);
    if (["Yesterday", "Today", "Tomorrow"].includes(input)) {
      if (input === "Today") {
        return {
          period: 1,
          value: undefined,
          unit: "Days",
        };
      }
      if (input === "Yesterday") {
        return {
          period: 0,
          value: undefined,
          unit: "Days",
        };
      }
      if (input === "Tomorrow") {
        return {
          period: 2,
          value: undefined,
          unit: "Days",
        };
      }
    }
  }
};

// function findSubCategoriesByCategory(category, data, dataObject) {
function findSubCategoriesByCategory({
  headingValue,
  xAxis,
  dimension,
  mainData,
  dataObject,
  metricVales,
}) {
  const subCategories = mainData
    .filter((item) => item[xAxis] === headingValue)
    .map((item) => item[dimension]); // Extract the sub-category

  // Step 2: Filter keys from dataObject that match the sub-categories
  const filteredValues = Object.keys(dataObject)
    .filter((key) => {
      const subCategory = key.split("|")[0]; // Extract sub-category from keys like 'Phones|SUM_Sales'
      return subCategories.includes(subCategory) || key.startsWith("Total"); // Check if sub-category exists in the list
    })
    .reduce((result, key) => {
      result[key] = dataObject[key]; // Include matching key-value pairs in the result
      return result;
    }, {});

  return {
    subCategories: subCategories.length > 0 && subCategories,
    filteredValues,
  };
}

function splitKeys(value) {
  if (value) {
    const valueWithOutPipe = value.split("|");
    console.log(valueWithOutPipe);
    return valueWithOutPipe[0];
  }
  return null;
}
const handleFilterInDashboard = ({
  item,
  dashIDs,
  dispatch,
  setCommonFilters,
}) => {
  console.log(item.rename);

  let updatedDashboardIDs;
  if (item.dashboardIDs) {
    const dashboardIDsArray = Array.isArray(item.dashboardIDs)
      ? item.dashboardIDs
      : [];
    console.log(dashboardIDsArray);
    updatedDashboardIDs = dashboardIDsArray.includes(dashIDs)
      ? dashboardIDsArray.filter((id) => {
          return id !== dashIDs;
        }) // Remove dashIDs if it exists
      : null;
  }
  console.log({ ...item, dashboardIDs: updatedDashboardIDs });

  dispatch(
    setCommonFilters({
      value: { ...item, dashboardIDs: updatedDashboardIDs },
      operation: "UPDATE",
      Sheetid: item.Sheetid,
    })
  );
};

const buildSortObject = (vizType, groupByKeys, rowKeys) => {
  let sortObject = null;
  const groupZeroIndexItem = groupByKeys[0];
  const rowZeroIndexItem = rowKeys[0];
  switch (vizType) {
    case "cordinatemap":
      sortObject = { isRandomSort: true };
      break;
    case "simpleTable":
      if (rowKeys.length > 0 && groupByKeys.length === 0) {
        if (rowZeroIndexItem.dataType === "Date") {
          sortObject = {
            columnName: rowZeroIndexItem.columnName,
            order: "ASC",
            format: rowZeroIndexItem.format,
          };
        }
        if (rowZeroIndexItem.dataType === "String") {
          sortObject = {
            columnName: rowZeroIndexItem.responseKey,
            order: "ASC",
            format: rowZeroIndexItem.format,
          };
        }
      } else {
        console.error("rows array is empty");
      }
    case "piechart":
    case "linechart":
    case "areachart":
    case "stackedbarchart":
    case "scatterchart":
    case "combochart":
    case "stackedbarchartimage":
      if (groupByKeys.length > 0 && rowKeys.length === 0) {
        if (groupZeroIndexItem.dataType === "Date") {
          sortObject = {
            columnName: groupZeroIndexItem.columnName,
            order: "ASC",
            format: groupZeroIndexItem.format,
          };
        }
        if (groupZeroIndexItem.dataType === "String") {
          sortObject = {
            columnName: groupZeroIndexItem.responseKey,
            order: "ASC",
            format: groupZeroIndexItem.format,
          };
        }
      } else {
        console.error("groupByFields array is empty");
      }
    default:
      break;
  }
  console.log(sortObject);
  if (sortObject) {
    return [sortObject];
  } else {
    return [];
  }
};

export {
  handleQuickTable,
  handleNumberObjectForQuickTable,
  findMatchedItems,
  breakValue,
  getDateUnitFormat,
  findSubCategoriesByCategory,
  splitKeys,
  handleFilterInDashboard,
  buildSortObject,
};
